import { formatAiAnswer } from './textFormat';

/**
 * 백엔드 DTO 데이터를 프론트엔드용 객체로 변환하고 필드를 보정하는 유틸리티.
 */
export const mapHistoryData = (data, currentUser = {}) => {
    return data.map(item => {
        let parsedRefs = { law_refs: [], citations: [] };
        let parsedMeta = {};

        try {
            if (item.retrieved_refs_json) parsedRefs = JSON.parse(item.retrieved_refs_json);
            if (item.meta_json) parsedMeta = JSON.parse(item.meta_json);
        } catch (e) {
            console.error('JSON parse error:', e);
        }

        const actualUserId = item.user_id || (currentUser && currentUser.id);
        let displayUserName = item.user_name || "익명 사용자";

        // 로그인한 사용자 본인의 항목일 때 이름 보정
        if (item.user_id && currentUser && String(item.user_id) === String(currentUser.id) && currentUser.name) {
            displayUserName = currentUser.name;
        }

        return {
            id: item.turn_id || item.id,
            user_id: actualUserId,
            user_name: displayUserName,
            company_code: (item.company_code && String(item.company_code).trim()) || '',
            company_name: (item.company_name && String(item.company_name).trim()) || '',
            question: item.question,
            answer: formatAiAnswer(item.answer || ""),
            created_at: item.chat_time || item.created_at,
            answer_status: item.status ? item.status.toLowerCase() : 'success',
            category: parsedMeta.category || "현장 안전 수칙",
            meta: {
                law_refs: parsedRefs.law_refs || [],
                citations: parsedRefs.citations || []
            }
        };
    });
};
